module.exports = __webpack_public_path__ + "static/img/bjlt.6261a2d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/bjlt.jpg
// module id = qO5L
// module chunks = 1